import { render } from "./OpenRhWebGives.vue?vue&type=template&id=ce5a965a"
import script from "./OpenRhWebGives.vue?vue&type=script&lang=js"
export * from "./OpenRhWebGives.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__